import { i18n } from '@client/helper/i18n';
const { t } = i18n;

export const musclePic = {
  // 正面
  front: {
    0: {
      name: t('S4208'),
      image: '0.png'
    },
    1: {
      name: t('S4224'),
      image: '1.png',
      lineImage: '1-line.png',
      position: {
        top: '14.1%',
        left: '5.6%'
      }
    },
    2: {
      name: t('S4225'),
      image: '2.png',
      lineImage: '2-line.png',
      position: {
        top: '24%',
        left: '5.6%'
      }
    },
    3: {
      name: t('S4226'),
      image: '3.png',
      lineImage: '3-line.png',
      position: {
        top: '28.1%',
        right: '5.6%'
      }
    },
    5: {
      name: t('S4228'),
      image: '5.png',
      lineImage: '5-line.png',
      position: {
        top: '37.6%',
        left: '5.6%'
      }
    },
    6: {
      name: t('S4229'),
      image: '6.png',
      lineImage: '6-line.png',
      position: {
        top: '42.8%',
        right: '6%'
      }
    },
    7: {
      name: t('S4230'),
      image: '7.png',
      lineImage: '7-line.png',
      position: {
        top: '55.7%',
        left: '6%'
      }
    },
    9: {
      name: t('S4231'),
      image: '9.png',
      lineImage: '9-line.png',
      position: {
        top: '61.4%',
        right: '6.7%'
      }
    },
    10: {
      name: t('S4232'),
      image: '10.png',
      lineImage: '10-line.png',
      position: {
        top: '50%',
        right: '5.6%'
      }
    },
    11: {
      name: t('S4233'),
      image: '11.png'
    },
    15: {
      name: t('S4237'),
      image: '15.png',
      lineImage: '15-line.png',
      position: {
        top: '72.2%',
        left: '6%'
      }
    },
    16: {
      name: t('T1125'),
      url: 'https://staticcn.coros.com/training/plan/common/images/musle/male/front/male_front_01.png'
    }
  },
  // 反面
  rear: {
    0: {
      name: t('S4208'),
      image: '0.png'
    },
    1: {
      name: t('S4224'),
      image: '1.png'
    },
    4: {
      name: t('S4227'),
      image: '4.png',
      lineImage: '4-line.png',
      position: {
        top: '27.9%',
        right: '6.5%'
      }
    },
    5: {
      name: t('S4228'),
      image: '5.png'
    },
    6: {
      name: t('S4229'),
      image: '6.png'
    },
    8: {
      name: t('S4266'),
      image: '8.png',
      lineImage: '8-line.png',
      position: {
        top: '65.2%',
        right: '7%'
      }
    },
    9: {
      name: t('S4231'),
      image: '9.png'
    },
    10: {
      name: t('S4232'),
      image: '10.png'
    },
    11: {
      name: t('S4233'),
      image: '11.png',
      lineImage: '11-line.png',
      position: {
        top: '16.2%',
        left: '6.7%'
      }
    },
    12: {
      name: t('S4234'),
      image: '12.png',
      lineImage: '12-line.png',
      position: {
        top: '31.4%',
        left: '6.7%'
      }
    },
    13: {
      name: t('S4235'),
      image: '13.png',
      lineImage: '13-line.png',
      position: {
        top: '54.7%',
        right: '6.5%'
      }
    },
    14: {
      name: t('S4236'),
      image: '14.png',
      lineImage: '14-line.png',
      position: {
        top: '49.3%',
        left: '7.1%'
      }
    },
    15: {
      name: t('S4237'),
      image: '15.png',
      lineImage: '15-line.png',
      position: {
        top: '76.2%',
        left: '5.8%'
      }
    },
    16: {
      name: t('T1125'),
      url: 'https://staticcn.coros.com/training/plan/common/images/musle/male/rear/male_rear_01.png'
    }
  }
};
